import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants, links, compose, mixpanel } from 'common/helpers'
import { useEffect } from 'sb-hooks'
import cx from 'classnames'

import injectGlobals from 'decorators/injectGlobals'

import Box from 'components/_new/layout/Box/Box'
import Modal from 'components/modal/Modal/Modal'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './OfferModal.scss'


const OfferModal = ({ name, gender, isMobile, pathname, data: { offerName } }) => {
  const isFemale          = gender === 'female'
  const withPersonImage   = offerName === constants.offerNames.off25
  const withWhiteButton   = isFemale && withPersonImage

  const sequence = `popup sequence ${({
    [constants.offerNames.secondMonthFree]:   2,
    [constants.offerNames.off50]:             3,
    [constants.offerNames.off25]:             4,
  })[offerName]}`

  const offer = ({
    [constants.offerNames.off50]:             'second',
    [constants.offerNames.off25]:             '50%',
    [constants.offerNames.secondMonthFree]:   '25%',
  })[offerName]

  const handleButtonClick = () => {
    mixpanel.track(constants.analyticsEvents.queuePopupClick, {
      placement: sequence,
    })

    if (offerName !== constants.offerNames.secondMonthFree) {
      actions.misc.cookies.setItem(constants.cookieNames.discountCoupon, constants.discountCoupons[offerName])
    }

    actions.misc.cookies.setItem(constants.cookieNames.offer, offerName)
    actions.view.paymentPage.setCouponWithForcedLowerValue(true)
    actions.models.ui.setClosedPopup(constants.modals.addToQueue.Offer)
    actions.models.modals.close(name)
  }

  const handleModalClose = () => {
    actions.models.ui.setClosedPopup(constants.modals.addToQueue.Offer)
  }

  const title = ({
    [constants.offerNames.off50]:             messages.titles.off50,
    [constants.offerNames.off25]:             messages.titles.off25,
    [constants.offerNames.secondMonthFree]:   messages.titles.secondMonthFree,
  })[offerName]

  const modalClassName = cx(s.modal, {
    [s.withPersonImage]: withPersonImage,
  })

  useEffect(() => {
    mixpanel.track(constants.analyticsEvents.queuePopup, {
      placement: pathname,
      type: sequence,
      gender,
      offer,
    })
  }, [])

  return (
    <Modal
      className={modalClassName}
      contentClassName={s.modalContent}
      name={name}
      fullScreenOnMobile={false}
      withWhiteCloseButton
      onClose={handleModalClose}
    >
      <Box className={s.content} alignLeft relative>
        <Text className={s.title} message={title} size="18-24" semibold />
        <Box mt="16">
          <Text message={messages.subText} />
        </Box>
        <Box mt={isMobile ? '24' : '48'}>
          <Button
            to={links.subscribe}
            doublePadding={!isMobile}
            title={messages.buttonTitle}
            color={withWhiteButton ? 'white' : 'brand'}
            weigth="medium"
            size="md"
            uppercase
            onClick={handleButtonClick}
          />
        </Box>
        <Box mt="16">
          <Text className={s.hint} message={messages.hint} />
        </Box>
      </Box>
    </Modal>
  )
}

OfferModal.propTypes = {
  name: PropTypes.string.isRequired,
  isMobile: PropTypes.bool, // @injectGlobals
  gender: PropTypes.string, // @connect
  pathname: PropTypes.string, // @connect
  data: PropTypes.shape({
    offerName: PropTypes.string,
  }),
}

OfferModal.defaultProps = {
  name: constants.modals.addToQueue.Offer,
  isMobile: false,
  data: {
    offerName: '',
  },
}


export default compose(
  injectGlobals(({ globals: { device: { isMobile } } }) => ({
    isMobile,
  })),
  connect({
    gender: 'models.me.gender',
    pathname: 'routing.location.pathname',
  })
)(OfferModal)
